import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    address: '',
    addressTitle: '',
    addressUrl: '',
    buttonText: '',
    code: '',
    directionButtonText: '',
    directionButtonType: '',
    embed: '',
    isMap: false,
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'card',
  },
  buttonDesign: {},
  itemDesign: {},
  containerDesign: {},
};

export const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    mapStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;

      const { itemDesign, buttonDesign, containerDesign } = block.blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.buttonDesign = buttonDesign ?? {};
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        address: blockContent.address ?? '',
        addressTitle: blockContent.addressTitle ?? '',
        addressUrl: blockContent.addressUrl ?? '',
        buttonText: blockContent.buttonText ?? '',
        code: blockContent.code ?? '',
        directionButtonText: blockContent.directionButtonText ?? '',
        directionButtonType: blockContent.directionButtonType ?? '',
        embed: blockContent.embed ?? '',
        isMap: blockContent.isMap ?? false,
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };
    },
    mapClear: () => initialState,

    mapUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    mapUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    mapUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    mapUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { mapUpdateIsLoading, mapStore, mapClear, mapUpdateIsActive, mapUpdateCTA, mapUpdateBlockContent, mapUpdateBlockDesign } = mapSlice.actions;

export const selectMapIsLoading = (state) => state.map.isLoading;

export const selectMapIsActive = (state) => state.map.isActive;
export const selectMapId = (state) => state.map.id;
export const selectMapUID = (state) => state.map.uid;
export const selectMapSID = (state) => state.map.sid;

export const selectMapBlockContent = (state) => state.map.blockContent;

export const selectMapSortItems = createSelector([selectMapBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectMapBlockDesign = (state) => state.map.blockDesign;
export const selectMapItemDesign = (state) => state.map.itemDesign;
export const selectMapButtonDesign = (state) => state.map.buttonDesign;
export const selectMapContainerDesign = (state) => state.map.containerDesign;

export default mapSlice.reducer;
